import { Injectable, DOCUMENT, inject } from '@angular/core';
import { ConsumerPortalApiService } from './consumer-portal-api.service';
import { Observable } from 'rxjs';
import { ContractPdfResponse } from '../models/pdf-response';

import { GetUrlRequest } from '../models/get-url-request';

@Injectable({
    providedIn: 'root'
})
export class PdfService {
    private readonly customerPortal = inject(ConsumerPortalApiService);
    private readonly document = inject<Document>(DOCUMENT);

    downloadPdf(customerId: string, contractId = '', documentField = '', documentValue = '', orgId?: string, orgType?: string): Observable<ContractPdfResponse> {
        /* eslint-disable @typescript-eslint/naming-convention */
        const headers: Record<string, string> = {};
        if (orgId) {
            headers['x-organization-id'] = orgId;
        }
        /* eslint-enable @typescript-eslint/naming-convention */
        let url = `customer/${customerId}/contracts/${contractId}/getpdf?DocumentField=${documentField}&DocumentValue=${documentValue}`;
        if (orgType) {
            url += `&OrgType=${encodeURIComponent(orgType)}`;
        }
        return this.customerPortal.get(url, { headers }) as unknown as Observable<ContractPdfResponse>;
    }

    getUrl(getUrlRequest: GetUrlRequest): Observable<ContractPdfResponse> {
        return this.customerPortal.get(
            `customer/${getUrlRequest.customerId}/contracts/${getUrlRequest.contractId}/geturl?Field=${getUrlRequest.linkField}`
        ) as unknown as Observable<ContractPdfResponse>;
    }

    openPdfinNewTab(url: string) {
        if (url) {
            const a = this.document.createElement('a');
            a.setAttribute('href', url);
            a.setAttribute('target', '_blank');
            a.click();
            a.remove();
        }
    }
}
